import { Theme } from '@emotion/react';
import { SxProps, TableCell } from '@mui/material';
import React from 'react';

interface CommonTableCellProps {
    value: React.ReactNode | string | number;
    formatDate?: boolean;
    textOverflow?: boolean;
    dateFormat?: string;
    style?: SxProps<Theme>;
    [key: string]: any;
}

const CommonTableCell = ({ value, formatDate = false, textOverflow = true, dateFormat = 'short', style, ...props }: CommonTableCellProps) => {

    const formatDateValue = (date: Date | string | number) => {
        if (typeof date === 'string') {
            date = date.trim().replace(/[^\dTZ:\-\.]+$/g, '').replace(/\.$/, '');
        }

        const parsedDate = date instanceof Date ? date : new Date(date);

        if (isNaN(parsedDate.getTime())) {
            return 'Invalid Date';
        }

        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        };

        return new Intl.DateTimeFormat('en-GB', options).format(parsedDate);
    };

    const isDateLike = (val: any): val is string | number | Date =>
        typeof val === 'string' || typeof val === 'number' || val instanceof Date;

    const formattedValue =
        formatDate && isDateLike(value) && !isNaN(new Date(value).getTime())
            ? formatDateValue(value)
            : value;

    return (
        <TableCell
            sx={{
                overflow: textOverflow ? 'hidden' : 'visible',
                textOverflow: textOverflow ? 'ellipsis' : 'clip',
                whiteSpace: 'nowrap',
                borderRight: '1px solid',
                borderLeft: '1px solid',
                borderColor: 'grey.300',
                ...style,
            }}
            {...props}
        >
            {formattedValue}
        </TableCell>
    );
};

export default CommonTableCell;
